import axios from 'axios';
import {instance} from '../index';
import {
  setActiveSession,
  setLogin,
  setModuleListByRole
} from '../../reducers/auth/index';

export const loginAction: any = (apiData) => async (dispatch: any) => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await instance.post(`Auth/SignIn`, apiData);
      resolve(res?.data);
      dispatch(setLogin(res?.data));
    } catch (error) {
      //@ts-ignore
      reject(error);
    }
  });
};

export const logOutAction: any = (apiData) => async (dispatch: any) => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await instance.post(`/Authentication/LogOut`, apiData); 
      resolve(res?.data);
    } catch (error) {
      //@ts-ignore
      reject(error);
    }
  });
};


export const profileAction: any = (apiData) => async (dispatch: any) => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await instance.patch(`/Admin/profile`, apiData); 
      resolve(res?.data);
    } catch (error) {
      //@ts-ignore
      reject(error);
    }
  });
};
 